/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type MarketRole = typeof MarketRole[keyof typeof MarketRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarketRole = {
  UNKNOWN: 'UNKNOWN',
  CSP: 'CSP',
  GDS: 'GDS',
  LNB: 'LNB',
  LV: 'LV',
  MV: 'MV',
  ODA: 'ODA',
  PV: 'PV',
  RNB: 'RNB',
  BSP: 'BSP',
} as const;
